module.exports = __webpack_public_path__ + "static/img/2.8dbe307a.svg";